import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { ApiBaseUrls, ApiControllers } from "../constants/constants";
import { APISanitizerUtilities } from "../utilities/api-sanitizer.utilities";
import { ServiceUtilities } from "../utilities/service.utilities";
import { ServiceResultModel } from "../models/service/service-result.model";
import {
    OrganizationMessageSuppressionModel,
    UpdateOrganizationMessageSuppressionRequest
} from "../models/data/organization-message-suppression.model";

@Injectable({
    providedIn: 'root'
})
export class OrganizationMessageSuppressionService {

    private httpClient = inject(HttpClient);

    private apiPath: string = `${ApiBaseUrls.MESSAGING()}${ApiControllers.ORGANIZATIONS()}`;

    public async getMessageSuppression(organizationId: number): Promise<ServiceResultModel<OrganizationMessageSuppressionModel | undefined>> {
        try {
            const requestUrl = this.apiPath + `/${organizationId}/${ApiControllers.MESSAGE_SUPPRESSION()}`;
            const response = await firstValueFrom(
                this.httpClient.get<OrganizationMessageSuppressionModel>(
                    requestUrl,
                    { observe: "response", headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
                )
            );
            const suppression = <OrganizationMessageSuppressionModel>response.body?.valueOf();
            return <ServiceResultModel>{ data: suppression, success: true, statusCode: response.status };
        } catch (error) {
            return ServiceUtilities.handleServiceException(error);
        }
    }

    public async updateMessageSuppression(
        organizationId: number,
        request: UpdateOrganizationMessageSuppressionRequest
    ): Promise<ServiceResultModel<OrganizationMessageSuppressionModel | undefined>> {
        try {
            const requestUrl = this.apiPath + `/${organizationId}/${ApiControllers.MESSAGE_SUPPRESSION()}`;
            const response = await firstValueFrom(
                this.httpClient.put<OrganizationMessageSuppressionModel>(
                    requestUrl,
                    JSON.stringify(APISanitizerUtilities.sanitizePayload<UpdateOrganizationMessageSuppressionRequest>(request)),
                    { observe: "response", headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
                )
            );
            const suppression = <OrganizationMessageSuppressionModel>response.body?.valueOf();
            return <ServiceResultModel>{ data: suppression, success: true, statusCode: response.status };
        } catch (error) {
            return ServiceUtilities.handleServiceException(error);
        }
    }
}
